<div
  data-cy="mat-dialog"
  [attr.data-cy-dialog-id]="(data$ | async)?.id">
  <h1
    *ngIf="(data$ | async)?.title"
    mat-dialog-title>
    {{ (data$ | async)?.title }}
  </h1>
  <h1
    *ngIf="!(data$ | async)?.title"
    mat-dialog-title>
    <ng-container *ngIf="(data$ | async)?.defaultImpolite; else defaultPolite">
      {{ "areYouSure" | i18n }}
    </ng-container>
    <ng-template #defaultPolite>
      {{ "areYouSurePolite" | i18n }}
    </ng-template>
  </h1>
  <div
    mat-dialog-content
    class="dialog-text"
    data-cy="dialog-content">
    {{ (data$ | async)?.text }}
  </div>
  <div
    *ngIf="(data$ | async)?.showNameInput"
    style="margin-top: 24px">
    {{ "pleaseEnterName" | i18n }}
    <mat-form-field style="margin-top: 8px">
      <input
        [ngModel]="(data$ | async)?.nameInput"
        (ngModelChange)="updateNameInput($event)"
        matInput
        name="name"
        [placeholder]="'name' | i18n | titlecase" />
    </mat-form-field>
  </div>
  <mat-checkbox
    *ngIf="(data$ | async)?.showDisableUnsavedChangesWarningCheckbox"
    [ngModel]="disableUnsavedChangesWarningCheckbox"
    (ngModelChange)="updateDisableUnsavedChangesWarningCheckbox($event)"
    name="disableUnsavedChangesWarning"
    style="margin-top: 16px; display: block"
    data-cy="dialog-disable-unsaved-changes-warning-checkbox">
    {{
      (data$ | async)?.disableUnsavedChangesWarningCheckboxLabel ||
        ("disableUnsavedChangesWarning" | i18n)
    }}
  </mat-checkbox>
  <div
    mat-dialog-actions
    *ngIf="!(data$ | async)?.singleAction">
    <button
      mat-button
      (click)="cancel()"
      data-cy="dialog-cancel">
      {{ data.cancelButtonLabel || ("cancel" | i18n) | uppercase }}
    </button>
    <button
      mat-button
      [disabled]="
        !!((data$ | async)?.showNameInput && !(data$ | async)?.nameInput)
      "
      [mat-dialog-close]="getDialogCloseValue()"
      data-cy="dialog-confirm">
      {{ data.confirmButtonLabel || ("confirm" | i18n) | uppercase }}
    </button>
  </div>
  <div
    mat-dialog-actions
    *ngIf="(data$ | async)?.singleAction">
    <button
      class="mat-primary"
      mat-button
      [mat-dialog-close]="">
      {{ (data$ | async)?.singleAction | uppercase }}
    </button>
  </div>
</div>
